import Accordion from 'accordion-js';
import 'accordion-js/dist/accordion.min.css';

const faqData = [
  {
    question:
      'Я мрію про пухнастика! Що мені потрібно зробити, щоб забрати хвостика додому?',
    answer: `
      <p>Це чудово, що ви готові подарувати дім одному з наших підопічних! Ми дуже раді будемо вам у цьому допомогти.
      Процес «усиновлення» у нас простий та зрозумілий:</p>
      <ul class="faq-list faq-list--numbered">
        <li>Оберіть друга: Придивіться до наших хвостиків у розділі «Знайди
            друга»</li>
        <li>Залиште заявку: Коли відчуєте, що це «ваша» тваринка, натискайте
            кнопку «Взяти додому» та заповніть коротку анкету</li>
        <li>Поговоріть з куратором: Наш волонтер зателефонує вам, щоб
            познайомитись ближче, розповісти про характер тваринки та відповісти
            на всі ваші питання.</li>
        <li>Приїжджайте знайомитись: Якщо ви ідеально підходите одне одному, ми
            домовимось про зустріч у притулку.</li>
        <li>Дорога додому: Після знайомства та підписання договору про
            відповідальне утримання, ваш новий друг поїде з вами у своє нове,
            щасливе життя!</li>
      </ul>
    `,
  },
  {
    question:
      'Як мені найкраще підготувати свій дім та родину до появи хвостика?',
    answer: `
      <p>Чудове питання, яке показує вашу турботу! Переїзд — це завжди
          невеликий стрес для тваринки, але правильна підготовка зробить цей
          процес легким і радісним. Ось кілька порад:</p>
      <ul class="faq-list faq-list--bulleted">
        <li>Безпечний простір: Переконайтесь, що на вікнах є сітки, а дроти та
            побутова хімія сховані</li>
        <li>Особисті речі: Підготуйте для хвостика дві мисочки (для їжі та
            води), лежанку чи будиночок, лоток з наповнювачем для котика або
            повідець і нашийник для собачки.</li>
        <li>Сімейна розмова: Обговоріть з рідними майбутні обов'язки. Важливо,
            щоб усі були готові до появи нового мешканця.</li>
        <li>Терпіння та любов: Дайте тваринці час, щоб звикнути. Не квапте її,
            будьте поруч, розмовляйте лагідним голосом — і ваша любов творитиме
            дива!</li>       
      </ul>
    `,
  },
  {
    question:
      'Чи можу я бути впевненим, що тваринка здорова? Розкажіть про щеплення.',
    answer: `
      <p>Так, звісно. Здоров'я наших підопічних — наш головний пріоритет. Кожна
          тваринка, яка потрапляє до нас, проходить повний огляд у ветеринара.
          Ми гарантуємо, що:</p>
      <ul class="faq-list faq-list--bulleted">
        <li>Усі хвостики оброблені від бліх та глистів.</li>
        <li>Усі вакциновані комплексною вакциною за віком.</li>
        <li>Дорослі тварини (зазвичай від 6-8 місяців) стерилізовані/кастровані.</li>
        <li>
           Приїжджайте знайомитись:  Якщо ви ідеально підходите одне одному, ми
          домовимось про зустріч у притулку.
          </li>
      </ul>
      <p>
          Разом із тваринкою ви обов'язково отримаєте її ветеринарний паспорт з
          усіма відмітками. Якщо у когось є особливі потреби у догляді чи
          харчуванні, ми чесно і детально про це розповімо.
        </p>
    `,
  },
  {
    question:
      'Я дуже хочу допомогти, але поки не готовий до адопції. Чим я можу підтримати «Хатинку лапок»?',
    answer: `
      <p>Дякуємо вам за велике серце та бажання допомогти! Кожна допомога для
          нас безцінна. Навіть якщо ви не можете взяти тваринку, ви можете стати
          її янголом-охоронцем. Ось як:</p>
      <ul class="faq-list faq-list--bulleted">
        <li>
            Допомогти фінансово: Ваша пожертва піде на корм, ліки, оплату
            комунальних послуг та зарплату персоналу.
          </li>
          <li>
            Стати волонтером: Нам завжди потрібні люблячі руки для прогулянок з
            собачками, прибирання та, найголовніше, для спілкування з
            тваринками.
          </li>
          <li>
            Подарувати необхідне: Ми завжди раді кормам, лікам, наповнювачам для
            лотків, іграшкам, теплим ковдрам.
          </li>
          <li>
            Допомогти інформаційно: Найпростіший, але дуже дієвий спосіб —
            розповідати про нас у соцмережах. Можливо, саме ваш репост допоможе
            комусь знайти свою долю!
          </li>
      </ul>
    `,
  },
  {
    question:
      'Мені сподобалась одна з ваших тваринок на сайті. Чи можу я приїхати, щоб познайомитися з нею особисто?',
    answer: `
        <p>
          Авжеж! Ми віримо, що справжня магія стається лише при особистій
          зустрічі. Щоб знайомство було комфортним і для вас, і для тваринки, ми
          просимо вас спочатку заповнити онлайн-заявку на нашому сайті.
        </p>
        <p>
          Після цього з вами зв'яжеться куратор тваринки, щоб домовитись про
          зручний час для вашого візиту. Такий підхід дозволяє нам приділити вам
          максимум уваги та уникнути зайвого стресу для наших підопічних. З
          нетерпінням чекаємо на знайомство!
        </p>`,
  },
];

export function initFaq() {
  const faqContainer = document.querySelector('.faq-container');
  if (!faqContainer) return;

  faqData.forEach(({ question, answer }) => {
    faqContainer.insertAdjacentHTML(
      'beforeend',
      `
      <div class="faq-item">
        <button class="faq-question">
          <span class="faq-question-text">${question}</span>
          <span class="icon">+</span>
        </button>
        <div class="faq-answer">
        <div class="faq-answer-inner">
          ${answer}
        </div>
        </div>
      </div>
      `
    );
  });

  new Accordion('.faq-container', {
    elementClass: 'faq-item',
    triggerClass: 'faq-question',
    panelClass: 'faq-answer',
    activeClass: 'active',
    openOnInit: [],
    collapse: true,
    showMultiple: false,
  });
}
